import styled from '@emotion/styled';
import { Magnetic } from "../../../styles";
export const StyledDivAvatarSpechBoxLayout = styled('div')(`
    padding: ${Magnetic.spacer24} ${Magnetic.spacer24} 0 ${Magnetic.spacer24};
`);
export const StyledDivBannerLayout = styled('div')(`
    margin: ${Magnetic.spacer24};
    word-break: break-word;
    #uam-block {
        border-radius : ${Magnetic.whiteLabelMobileSpeechBoxBorderRadius};
    }
`);
//# sourceMappingURL=WhiteLabelMobileCarrierSection.style.js.map